// All strings:
// https://github.com/aws-amplify/amplify-js/blob/main/packages/amplify-ui-components/src/common/Translations.ts

export default  {
    'cs': {
        'Sign in to your account': 'Přihlašte se do svého účtu',
        'Email Address *': 'E-mailová adresa *',
        'Enter your email address': 'Zadejte svůj e-mail',
        'Enter your Username': 'Zadejte svůj e-mail',
        'Enter your password': 'Zadejte své heslo',
        'Enter your code': 'Vložte Váš kód',
        'User is not confirmed.': 'Účet není potvrzen',
        'Sign in': 'Přihlásit se',
        'Sign In': 'Přihlásit se',
        'Password *': 'Heslo *',
        'Password': 'Heslo',
        'Phone Number *': 'Telefon',
        'No account?': 'Nemáte ještě účet?',
        'Create a new account': 'Vytvořit nový účet',
        'Forgot your password?': 'Zapomněli jste své heslo?',
        'Reset password': 'Obnovit heslo',
        'New password': 'Nové heslo',
        'Name': 'Jméno',
        'Have an account?': 'Máte už účet?',
        'Create account': 'Vytvořit',
        'Create Account': 'Vytvořit účet',
        'Reset your password': 'Obnovit zapomenuté heslo',
        'Back to Sign In': 'Zpět na přihlášení',
        'Send code': 'Poslat kód',
        'Send Code': 'Poslat kód',
        'User does not exist.': 'Uživatel neexistuje nebo heslo není platné.',
        'Confirm Sign up': 'Potvrdit přihlášení',
        'Confirmation code': 'Potvrzovací kód (byl Vám zaslán na e-mail)',
        'Confirmation Code': 'Potvrzovací kód (byl Vám zaslán na e-mail)',
        'Lost your code?': 'Kód Vám nedorazil?',
        'Resend Code': 'Znovu zaslat',
        'Confirm': 'Potvrdit',
        'Incorrect username or password.': 'Neplatné jméno nebo heslo.',
        'Password did not conform with policy: Password not long enough': 'Heslo nesplňuje požadavky: Nedostatečně dlouhé',
        'An account with the given email already exists.': 'Účet s tímto e-mailem už existuje.',
        'Enter code': 'Vložte kód z e-mailu',
        'Enter your new password': 'Vložte nové heslo'
    }
};